import { DateTime } from "luxon";
import { DateHelper } from "../../../../Common/DateHelper";
import { ODataSelect } from "../../../../Providers.Api/ODataQuery";
import { TypeHelper } from "../../../../Common/TypeHelper";

export class VisitDetail extends ODataSelect
{
    public Visit_Id = '';
    public Space_Id = '';
    public Booking_Id = '';
    public Booking_Start = DateHelper.null();
    public Booking_End = DateHelper.null();
    public Booking_Name = '';
    public Space_Name = '';
    public Visitor_First_Name = '';
    public Visitor_Last_Name = '';
    public Visitor_Email = '';
    public Visitor_Company = '';
    public Visit_Host_Name = '';
    public Visit_Host_Email = '';
    public Visit_Start_Date = DateHelper.null();
    public Visit_End_Date = DateHelper.null();
    public Visit_Approve_Time = DateHelper.null();
    public Visit_CheckIn_Time = DateHelper.null();
    public Visit_CheckOut_Time = DateHelper.null();
    public Visit_Deny_Time = DateHelper.null();
    public Visit_IsCheckedIn = 0;
    public Visit_IsApproved = 0;
    public Visit_IsCancelled = 0;
    public Visit_IsNoShow = 0;
    public Visit_IsCheckedOut = 0;
    public Visit_Status = '';
    public Visit_IsDenied = 0;
    public Visit_Pacs_Id = '';
    public VisitorTypeId = '';
    public CheckInWorkflowRaw: ICheckInWorkflowRaw = { Steps: [] };
    public CheckInWorkflow: ICheckInWorkflow = { Steps: [] };

    public init(response: any, nodeId: number): VisitDetail
    {
        super.init(response, nodeId);
        this.Booking_Start = DateHelper.fromIsoByNode(response.Booking_Start, nodeId);
        this.Booking_End = DateHelper.fromIsoByNode(response.Booking_End, nodeId);
        this.Visit_Start_Date = DateHelper.fromIsoByNode(response.Visit_Start_Date, nodeId);
        this.Visit_End_Date = DateHelper.fromIsoByNode(response.Visit_End_Date, nodeId);
        this.Visit_Approve_Time = DateHelper.fromIsoByNode(response.Visit_Approve_Time, nodeId);
        this.Visit_CheckIn_Time = DateHelper.fromIsoByNode(response.Visit_CheckIn_Time, nodeId);
        this.Visit_CheckOut_Time = DateHelper.fromIsoByNode(response.Visit_CheckOut_Time, nodeId);
        this.Visit_Deny_Time = DateHelper.fromIsoByNode(response.Visit_Deny_Time, nodeId);
        
        try
        {
            this.CheckInWorkflowRaw = JSON.parse(response.CheckInWorkflow);
            this.CheckInWorkflow = JSON.parse(response.CheckInWorkflow);
            this.CheckInWorkflow.Steps.flatMap(i => i.Questions).map(i => i.MaxLength = TypeHelper.toNumber(i.MaxLength as unknown as string) ?? 0);
            this.CheckInWorkflow.Steps.flatMap(i => i.Questions).flatMap(i => i.Answers).map(i => i.ModifiedAt = DateHelper.fromIsoByNode(i.ModifiedAt as unknown as string, nodeId));
        }
        catch
        {
            this.CheckInWorkflowRaw = { Steps: [] };
            this.CheckInWorkflow = { Steps: [] };
        }
        return this;
    }
}

export interface ICheckInWorkflowRaw
{
    Steps: ICheckInWorkflowStepRaw[];
}

export interface ICheckInWorkflowStepRaw
{
    Questions: ICheckInWorkflowQuestionRaw[];
}

export interface ICheckInWorkflowQuestionRaw
{
    Id: string;
    Answers: ICheckInWorkflowAnswerRaw[];
}

export interface ICheckInWorkflowAnswerRaw
{
    Value: string;
    ModifiedAt: string;
    ModifiedBy: string;
}

export interface ICheckInWorkflow
{
    Steps: ICheckInWorkflowStep[];
}

export interface ICheckInWorkflowStep
{
    Questions: ICheckInWorkflowQuestion[];
}

export interface ICheckInWorkflowQuestion
{
    Id: string;
    InputType: QuestionType;
    Value: string;
    Name: string;
    QuestionName: string;
    PolicyText: string;
    ConfirmationText: string;
    PlaceHolderText: string;
    HelperText: string;
    InputHeight: InputHeight;
    MaxLength: number;
    Labels: ICheckInWorkflowLabel[];
    Answers: ICheckInWorkflowAnswer[];
}

export interface ICheckInWorkflowLabel
{
    Label: string;
}

export interface ICheckInWorkflowAnswer
{
    Value: string;
    ModifiedAt: DateTime;
    ModifiedBy: string;
}

export enum QuestionType
{
    NotSet = -1,
    QuestionTypeOpen = 1,
    QuestionTypeMultiOptionSingleSelect = 3,
    QuestionTypeTrueFalse = 0,
    QuestionTypePolicy = 2,
    NonQuestionTypeHeader = 4,
    NonQuestionTypeSubHeader = 5,
    NonQuestionTypeImage = 6,
}

export type InputHeight = '' | 'single' | 'multi';

export class Space extends ODataSelect
{
    public Space_Name = '';
    public Space_Id = '';
    public Space_Custom_Info = '';
    public Booking_Policy_Id = '';
    public ImageURI = '';
    public Space_Class = '';
    public Space_Type = '';
    public Space_Work_Type = '';
    public Space_Type_Label = '';
    public Space_Capacity = 0;
    public Meta_Loc_Zone = '';
    public Meta_Loc_X_m = 0;
    public Meta_Loc_Y_m = 0;
    public Meta_Bookable = 0;
    public Meta_Dig_Sign_Type = 0;
    public Meta_Occ_Type = 0;
    public Meta_Sol_Thld_Min = 0;
    public Env_Temperature_Range = 0;
    public Env_Sound_Level_Range = 0;
    public Space_IsEnabled = 0;
    public Env_Zone_Id = 0;
}
